export const NAVIGATION_PUSH_THROTTLE_MS = 1_000;

export const getNavigationSignature = (path: string, state: object = {}) => {
  try {
    return `${path}:${JSON.stringify(state)}`;
  } catch {
    return path;
  }
};

export const createNavigationThrottle = (
  throttleTimeMs = NAVIGATION_PUSH_THROTTLE_MS
) => {
  let lastSignature: string | null = null;
  let lastNavigationAt: number | null = null;

  return (signature: string, currentTime = Date.now()): boolean => {
    if (
      signature === lastSignature &&
      lastNavigationAt !== null &&
      currentTime - lastNavigationAt < throttleTimeMs
    ) {
      return false;
    }

    lastSignature = signature;
    lastNavigationAt = currentTime;
    return true;
  };
};
